import { createStyles, makeStyles, Popper, TextField } from "@material-ui/core";
import { TextFieldProps as BaseTextFieldProps } from '@material-ui/core/TextField/TextField';
import Autocomplete, { AutocompleteInputChangeReason, createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';
import React, { ChangeEvent, useRef, useState } from "react";
import { Controller } from "react-hook-form";

export type ComboProps = any & BaseTextFieldProps;

//allowCodeSearch: Buscar pelo codigo/id, e nao só pelo label. Se searchFunction for informado, esta fc tambem deve considerar o codigo na pesquisa (vide componente SelectUser.tsx)
//showDetailedOptions: Exibir o code abaixo do id em cada opcao do Autocomplete (ex SelectUser.tsx)
const ComboBox: React.FC<ComboProps> = ({marginGird, name, label, options, control, multiple, defaultValue, style, autoWidth,
  searchFunction, onChange, onKeyUp, onInputChangeAditional, inputRef, allowSelectValueNotFound, allowEnterKey, disabled, autoFocus=false, setValue, showDefailedOptions=false, allowCodeSearch=false, freeSolo=false, debounceMs=300}) => {
    const [optionsLocal, setOptionsLocal] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false);

    const useStyles = makeStyles(() =>
    createStyles({
        root: {
          margin: marginGird ? marginGird : '10px',
          "& .MuiAutocomplete-tag":{
            margin: "6px",
          },
          "& .MuiChip-root":{
            margin: '3px',
            marginTop: "0px",
            marginBottom: "0px",
            height: '29px',
          },          
        },
        lightText: {
          color: "#999"
        }
    })
  );

  const classes = useStyles();

  const timeoutRef = useRef<any>(null);


  const onInputChange = (event: ChangeEvent<{}>, value: string, reason: AutocompleteInputChangeReason) => {
    setOptionsLocal([]);
    //if(value.length == 0 || value.length < props.minChar || (defaultValue != null && value == defaultValue.label)) {
    if(value.length == 0 || (defaultValue != null && value == defaultValue.label)) {
      setOptionsLocal([])
      return
    }

    if (onInputChangeAditional)
      onInputChangeAditional(value)

    if(searchFunction){
      setLoading(true)
      window.clearTimeout(timeoutRef.current);
      
        timeoutRef.current = window.setTimeout(async () => {
        searchFunction(value).then((result: any) => {
          if (result) {
              setOptionsLocal(result);
              setLoading(false);
          }
        }).finally(() => {
          setLoading(false);
        });
      }, debounceMs);
    }
  }

  function processPossibleOption(label: string, current: any) {

    var newOption = null
    
    if(options && options.length > 0) {
      var possible = options.filter((opt: {label: string}) => opt.label.toUpperCase().includes(label.toLocaleUpperCase()))

      newOption = possible.length > 0 ?  possible[0] : null
    }
    else if (optionsLocal.length > 0) 
      newOption = optionsLocal[0]
    else if (allowSelectValueNotFound != false)
      newOption = {code: label, label: label}
    
    if (multiple == true && newOption != null)
      return [...current, newOption]
    else if (multiple == true)
      return current

    return newOption
  }

  const onChange_ = async (value: []) =>{
    let newList:any[] = [];
    value.forEach((x: any) => {
        if (!newList.find((y: any) => y.code == x.code))
            newList.push(x);

    });
    setValue(name, newList);
  }

  const filterOptions = createFilterOptions({ stringify: (option:any) => ( `${option.code} ${option.label}`) });

  const styles = ({
    popper: {
      minWidth: "max-content",
    }
  });

  const PopperMy = function (props: any) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };
 

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: props, fieldState: { error } }) => (
        <Autocomplete
          freeSolo={freeSolo}
          PopperComponent={autoWidth ? PopperMy : undefined}
          limitTags={0}
          getLimitTagsText={(more) => (
            <label>{more} itens selecionados</label>
          )}
          value={props.value}
          disabled={disabled}
          loadingText={"Buscando..."}
          
          onChange={(_, data) => {

            props.onChange(data); 
            if (onChange)              
              onChange(data)
            
            if (setValue)
              onChange_(data)
          }}
          style={style}
          openOnFocus={true}
          onInputChange={onInputChange}
          options={searchFunction ? optionsLocal : options }
          multiple={multiple}
          defaultValue={options ? defaultValue : null}
          getOptionLabel={(option) => {
            return option.label !== undefined && option.label !== null ? option.label.toString() : ""}
          }
          getOptionSelected={(option: any, value: any) => {
              return option.label !== undefined ? option === value : false;
          }}
          renderOption={showDefailedOptions ? (item) => (<div>{item.label}<br/><small className={classes.lightText}>{item.code}</small></div>) : undefined}
          filterOptions={allowCodeSearch ? filterOptions : undefined}
          renderInput={(params) => (
            <TextField  
              {...params} 
              style={style}
              error={!!error}
              helperText={error ? error.message : null}
              className={clsx(classes.root)}
              label={label} 
              onKeyDown={(e: any) => {
                if (e.key == 'Enter') {

                  var option = processPossibleOption(e.target.value, props.value)
                  
                  props.onChange(option); 
            
                  if (onChange)              
                    onChange(option)

                  if (!(allowEnterKey ?? true))
                    e.preventDefault();
                }
              }}
              onKeyUp={onKeyUp}
              inputRef={inputRef}
              InputProps={{
                ...params.InputProps,
                autoFocus,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              InputLabelProps={{
                shrink:true
              }}
            />
          )}
        />
      )}
    />
  );
};
export default ComboBox;
